import { Tag, Typography } from "antd";

// Renders a result-band tag (KPI / report / domain bands), coloured by the band's own colour;
// a muted "—" when there's no resolved band. Shared by the report-review tables + the answer viewer
// so band rendering stays uniform.
function BandTag({
  label,
  color,
}: {
  readonly label?: string | null;
  readonly color?: string | null;
}) {
  if (!label) return <Typography.Text type="secondary">—</Typography.Text>;
  return <Tag color={color || undefined}>{label}</Tag>;
}

export default BandTag;
